var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,5.3V3H3v14h7v-2.3c0-0.4,0.3-0.7,0.7-0.7h0.6c0.4,0,0.7,0.3,0.7,0.7V18c0,0.6-0.4,1-1,1H2c-0.6,0-1-0.4-1-1V2 c0-0.6,0.4-1,1-1h9c0.6,0,1,0.4,1,1v3.3C12,5.7,11.7,6,11.3,6h-0.6C10.3,6,10,5.7,10,5.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8,10.7l-3.4,3.4c-0.2,0.2-0.6,0.2-0.8,0L15,13.5c-0.2-0.2-0.2-0.6,0-0.8l1.7-1.7h-7C9.3,11,9,10.7,9,10.3V9.7 C9,9.3,9.3,9,9.7,9h7L15,7.3c-0.2-0.2-0.2-0.6,0-0.8l0.6-0.6c0.2-0.2,0.6-0.2,0.8,0l3.4,3.4C20.2,9.7,20.2,10.3,19.8,10.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout20);
export default __webpack_public_path__ + "static/media/logout-20.76b22cf2.svg";
export { ForwardRef as ReactComponent };